/*
  Trend Circuit storefront interactions (2026-10-08, hardened 2026-10-09).

  1. Cart icon shake on add, repeated every 8s while the cart has items.
  2. Fly to cart: the product photo flies into the bag before it shakes.
  3. "Added" state on the button that was pressed.
  4. Free shipping progress bar kept current after an add.
  5. Second photo on hover for homepage cards (loaded on first hover).
  6. Save for later hearts, kept in this browser only (localStorage).
  7. Recently viewed row on product and cart pages.

  It only ever READS the cart (/cart.js, and the cart icon section after a
  Back navigation). Every block fails quiet: a missing element skips that
  feature, and a failed request never erases anything the shopper saved.
*/
(function () {
  'use strict';

  var SAVED_KEY = 'tc_saved_v1';
  var SEEN_KEY = 'tc_seen_v1';
  var SAVED_URL = '/pages/saved';
  var SAVED_MAX = 60;
  var SEEN_MAX = 12;
  var CARD_SEL = '.tc-card, .product-card-wrapper, .tc-mini';
  var HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-7.5-10.4A4.1 4.1 0 0 1 12 7.6a4.1 4.1 0 0 1 7.5 2.5c0 5.8-7.5 10.4-7.5 10.4z"/></svg>';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ---------- storage ---------- */
  // Some browsers refuse storage outright (locked-down or private modes). The
  // lists then live in memory, so hearts still work for the visit.
  var mem = {};
  var storageOk = true;
  function readList(key) {
    var raw = null;
    if (storageOk) {
      try {
        raw = window.localStorage.getItem(key);
      } catch (e) {
        storageOk = false;
      }
    }
    if (!storageOk) raw = mem[key] || null;
    var out = [];
    try {
      var v = JSON.parse(raw || '[]');
      if (Array.isArray(v)) {
        // Whatever is in there, only clean, unique product handles come out.
        v.forEach(function (h) {
          if (typeof h === 'string' && h && h.length < 256 && out.indexOf(h) === -1) out.push(h);
        });
      }
    } catch (e) {}
    return out;
  }
  function writeList(key, list) {
    var raw = JSON.stringify(list);
    if (storageOk) {
      try {
        window.localStorage.setItem(key, raw);
        return;
      } catch (e) {
        storageOk = false;
      }
    }
    mem[key] = raw;
  }

  function handleFromUrl(url) {
    var m = /\/products\/([^/?#]+)/.exec(url || '');
    if (!m) return null;
    try {
      return decodeURIComponent(m[1]);
    } catch (e) {
      return m[1];
    }
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  }

  var path = window.location.pathname.replace(/\/$/, '');
  var pageHandle = handleFromUrl(path);
  var onCartPage = /\/cart$/.test(path);
  // A "/products/..." address can also be a not-found page.
  function isProductPage() {
    return !!pageHandle && !!$('.product__info-container');
  }

  /* ---------- 1. cart icon shake ---------- */
  var shakeTimer;
  var lastShake = 0;
  function shake() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    lastShake = Date.now();
    clearTimeout(shakeTimer);
    icon.classList.remove('tc-cart-added');
    void icon.offsetWidth;
    icon.classList.add('tc-cart-added');
    shakeTimer = setTimeout(function () {
      icon.classList.remove('tc-cart-added');
    }, 1600);
  }
  // Reminder: while something is in the cart, shake again every few seconds.
  // Skipped on the cart page (they are already there) and in hidden tabs.
  function nudge() {
    if (onCartPage || document.hidden) return;
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon || !icon.querySelector('.cart-count-bubble')) return;
    var panel = document.getElementById('cart-notification');
    if (panel && panel.classList.contains('active')) return;
    // Not right on top of the shake that follows an add.
    if (Date.now() - lastShake < 6000) return;
    shake();
  }
  setTimeout(function () {
    nudge();
    setInterval(nudge, 8000);
  }, 3000);

  /* ---------- which button started an add ---------- */
  // The theme's cart events carry the variant id, so each one can be tied back
  // to the exact button that was pressed, even when several adds overlap.
  var presses = [];
  var pendingProxy = null;
  document.addEventListener(
    'click',
    function (e) {
      var proxy = e.target && e.target.closest ? e.target.closest('[data-tc-buybar-btn]') : null;
      if (proxy) pendingProxy = { el: proxy, at: Date.now() };
    },
    true
  );
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.closest || !form.closest('product-form')) return;
      var btn = form.querySelector('[name="add"]') || form.querySelector('[type="submit"]');
      // The theme ignores a press while one is already in flight; so do we.
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var idInput = form.querySelector('[name="id"]');
      var now = Date.now();
      // Where the pressed control sits on screen right now. The phone buy bar
      // slides away once the "Item added" panel opens, so this cannot be
      // measured later, when the photo is ready to fly.
      var pressed = pendingProxy && now - pendingProxy.at < 400 ? pendingProxy.el : btn;
      var pr = pressed.getBoundingClientRect();
      presses.push({
        el: btn,
        at: now,
        variant: idInput ? String(idInput.value) : '',
        rect: { left: pr.left, top: pr.top, right: pr.right, bottom: pr.bottom, width: pr.width, height: pr.height },
        used: false,
      });
      pendingProxy = null;
      if (presses.length > 10) presses.shift();
    },
    true
  );
  function claimPress(variantId) {
    var now = Date.now();
    var vid = variantId == null ? '' : String(variantId);
    var i;
    for (i = presses.length - 1; i >= 0; i--) {
      if (!presses[i].used && now - presses[i].at < 30000 && vid && presses[i].variant === vid) {
        presses[i].used = true;
        return presses[i];
      }
    }
    for (i = presses.length - 1; i >= 0; i--) {
      if (!presses[i].used && now - presses[i].at < 30000) {
        presses[i].used = true;
        return presses[i];
      }
    }
    return null;
  }

  /* ---------- 2. fly to cart ---------- */
  function photoFor(btn) {
    var card = btn.closest('.tc-card');
    if (card) return $('.tc-card__image', card);
    var modal = btn.closest('quick-add-modal');
    if (modal) return $('.product__media img', modal);
    return $('.product__media-item.is-active .product__media img') || $('.product__media-list .product__media img') || $('.product__media img');
  }
  function onScreen(r) {
    return r && r.width > 10 && r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }
  // Returns how long the flight takes in ms, or 0 if nothing flew.
  function fly(btn, pressRect) {
    var icon = document.getElementById('cart-icon-bubble');
    var img = btn && photoFor(btn);
    if (!icon || !img || !document.body.animate) return 0;
    var src = img.currentSrc || img.src;
    if (!src) return 0;
    var to = icon.getBoundingClientRect();
    if (!onScreen(to)) return 0;

    var r = img.getBoundingClientRect();
    var size, cx, cy;
    if (onScreen(r)) {
      size = Math.min(r.width, r.height, 170);
      cx = r.left + r.width / 2;
      cy = r.top + r.height / 2;
    } else {
      // Photo is scrolled away (phone buy bar): lift off from where the
      // button was when it was pressed.
      var b = pressRect;
      if (!b || !onScreen(b)) return 0;
      size = 64;
      cx = b.left + b.width / 2;
      cy = b.top - size / 2;
    }
    var el = document.createElement('img');
    el.src = src;
    el.alt = '';
    el.className = 'tc-flyer';
    el.style.cssText = 'left:' + (cx - size / 2) + 'px;top:' + (cy - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px';
    document.body.appendChild(el);
    var dx = to.left + to.width / 2 - cx;
    var dy = to.top + to.height / 2 - cy;
    var lift = Math.min(70, Math.abs(dy) * 0.25);
    var done = function () {
      if (el.parentNode) el.parentNode.removeChild(el);
    };
    try {
      var a = el.animate(
        [
          { transform: 'translate(0,0) scale(1)', opacity: 1 },
          { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - lift) + 'px) scale(0.5)', opacity: 1, offset: 0.55 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)', opacity: 0.35 },
        ],
        { duration: 700, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );
      a.onfinish = done;
      a.oncancel = done;
    } catch (e) {
      done();
      return 0;
    }
    setTimeout(done, 1200);
    return 700;
  }

  // The header may still be sliding back into view when an add lands. Wait
  // until the cart icon is on screen and has stopped moving (two looks 100ms
  // apart agree), then report true. Gives up quietly after about 1.5 seconds.
  function whenIconSettled(cb) {
    var tries = 0;
    var lastTop = null;
    (function look() {
      var icon = document.getElementById('cart-icon-bubble');
      var r = icon ? icon.getBoundingClientRect() : null;
      var ok = onScreen(r);
      if (ok && lastTop !== null && Math.abs(r.top - lastTop) < 0.5) {
        cb(true);
        return;
      }
      lastTop = ok ? r.top : null;
      if (++tries > 14) {
        cb(false);
        return;
      }
      setTimeout(look, 100);
    })();
  }

  /* ---------- 3. "Added" button state ---------- */
  // The tick mark comes from a fallback font and makes a button a hair taller.
  // On a phone that nudged the whole page, and the theme reads any nudge as a
  // scroll and tucks the header away behind the "Item added" panel. So the
  // button's height is held while its label is swapped.
  function holdHeight(el) {
    var h = el.getBoundingClientRect().height;
    if (!h) return function () {};
    var cs = window.getComputedStyle(el);
    if (cs.boxSizing !== 'border-box') {
      h -= parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
    }
    var prev = el.style.height;
    el.style.height = h + 'px';
    return function () {
      el.style.height = prev;
    };
  }
  function showAdded(btn) {
    if (!btn || btn.getAttribute('data-tc-added')) return;
    var holder = btn.querySelector(':scope > span:not(.sold-out-message):not(.loading__spinner)') || btn;
    var old = holder.textContent;
    var proxy = btn.classList.contains('product-form__submit') ? $('[data-tc-buybar-btn]') : null;
    var release = holdHeight(btn);
    var releaseProxy = proxy ? holdHeight(proxy) : null;
    btn.setAttribute('data-tc-added', '1');
    holder.textContent = '✓ Added';
    btn.classList.add('tc-added');
    if (proxy) proxy.classList.add('tc-added');
    setTimeout(function () {
      if (holder.textContent === '✓ Added') holder.textContent = old;
      btn.classList.remove('tc-added');
      if (proxy) proxy.classList.remove('tc-added');
      btn.removeAttribute('data-tc-added');
      release();
      if (releaseProxy) releaseProxy();
    }, 1800);
  }

  // Homepage cards had nowhere to show why an add failed ("only 1 left and it
  // is already in your cart"), so the button looked broken. Shopify's own
  // message goes into the card's alert line. Product pages show theirs already.
  function showCardError(btn, event) {
    var card = btn && btn.closest('.tc-card');
    var box = card && card.querySelector('[id^="tc-card-error-"]');
    if (!box) return;
    var text = typeof event.errors === 'string' ? event.errors : event.message;
    if (typeof text !== 'string' || !text || text === 'Cart Error') text = 'This item could not be added to your cart.';
    box.textContent = text;
    box.classList.add('tc-card__error');
    box.style.display = 'block';
    clearTimeout(box._tcTimer);
    box._tcTimer = setTimeout(function () {
      box.style.display = 'none';
    }, 8000);
  }

  /* ---------- 4. free shipping progress ---------- */
  function paintShip(el, total, grams) {
    var goal = parseInt(el.getAttribute('data-goal'), 10);
    if (!goal || typeof total !== 'number' || isNaN(total)) return;
    // Over the weight limit the offer does not apply at all (see the snippet).
    var maxGrams = parseInt(el.getAttribute('data-max-grams'), 10);
    if (maxGrams && typeof grams === 'number' && grams > maxGrams) {
      el.hidden = true;
      return;
    }
    var done = total >= goal;
    var msg = $('[data-tc-ship-msg]', el);
    var fill = $('[data-tc-ship-fill]', el);
    if (fill) fill.style.width = Math.max(4, Math.min(100, (total / goal) * 100)) + '%';
    el.classList.toggle('is-done', done);
    if (msg) msg.textContent = done ? 'You have free ground shipping' : "You're " + money(goal - total) + ' away from free ground shipping';
    el.hidden = total <= 0;
  }
  // Only the newest answer is used, and if the cart total cannot be read the
  // panel's bar hides: saying nothing beats showing an old number.
  var shipSeq = 0;
  function refreshShip() {
    var bars = $all('[data-tc-ship]');
    if (!bars.length) return;
    var mine = ++shipSeq;
    getJson('/cart.js')
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        if (mine !== shipSeq) return;
        if (!cart || typeof cart.total_price !== 'number') throw new Error('no total');
        bars.forEach(function (el) {
          paintShip(el, cart.total_price, cart.total_weight);
        });
      })
      .catch(function () {
        if (mine !== shipSeq) return;
        bars.forEach(function (el) {
          if (el.closest('#cart-notification')) el.hidden = true;
        });
      });
  }

  /* ---------- wiring to the theme's cart events ---------- */
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }
  onReady(function () {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || (event.source !== 'product-form' && event.source !== 'quick-add')) return;
      if (navigator.vibrate) {
        try {
          navigator.vibrate(20);
        } catch (e) {}
      }
      var press = claimPress(event.productVariantId);
      var btn = press ? press.el : null;
      showAdded(btn);
      refreshShip();
      whenIconSettled(function (ready) {
        var ms = ready && btn ? fly(btn, press.rect) : 0;
        setTimeout(shake, ms ? ms - 80 : 150);
      });
    });
    if (PUB_SUB_EVENTS.cartError) {
      subscribe(PUB_SUB_EVENTS.cartError, function (event) {
        if (!event || event.source !== 'product-form') return;
        var press = claimPress(event.productVariantId);
        if (press) showCardError(press.el, event);
      });
    }
  });

  /* ---------- "Item added" panel on short screens ---------- */
  // The panel hangs under the header and never scrolled, so on a phone held
  // sideways its buttons ran off the bottom of the screen, and adding the
  // shipping bar to it made that worse (844x390: Check out could not be
  // reached). While it is open it is now capped to the space under the header
  // and scrolls inside itself. The phone buy bar steps aside for as long as
  // the panel is open, so it cannot sit on top of the panel's last button.
  function watchPanel() {
    var panel = document.getElementById('cart-notification');
    if (!panel || !('MutationObserver' in window)) return;
    var root = document.documentElement;
    var until = 0;
    var ticking = false;
    var clearTimer;
    function isOpen() {
      return panel.classList.contains('active');
    }
    function fit() {
      if (!isOpen()) return;
      var wrap = panel.parentNode;
      var top = wrap && wrap.getBoundingClientRect ? Math.max(0, wrap.getBoundingClientRect().top) : 0;
      var vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      var max = Math.max(140, Math.floor(vh - top)) + 'px';
      if (panel.style.maxHeight !== max) panel.style.maxHeight = max;
      panel.style.overflowY = 'auto';
      panel.style.overscrollBehavior = 'contain';
    }
    function tick() {
      fit();
      if (Date.now() < until && isOpen()) window.requestAnimationFrame(tick);
      else ticking = false;
    }
    function follow(ms) {
      until = Math.max(until, Date.now() + ms);
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(tick);
    }
    function sync() {
      clearTimeout(clearTimer);
      if (isOpen()) {
        root.classList.add('tc-panel-open');
        fit();
        follow(900); // the header may still be sliding back into view
      } else {
        root.classList.remove('tc-panel-open');
        // let it slide away first, then give it its natural size back
        clearTimer = setTimeout(function () {
          if (isOpen()) return;
          panel.style.maxHeight = '';
          panel.style.overflowY = '';
          panel.style.overscrollBehavior = '';
        }, 400);
      }
    }
    new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class'] });
    function onMove() {
      if (isOpen()) follow(350);
    }
    window.addEventListener('resize', onMove);
    window.addEventListener('scroll', onMove, { passive: true });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', onMove);
    sync();
  }

  /* ---------- 5. second photo on hover (homepage cards) ---------- */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener(
      'mouseover',
      function (e) {
        var wrap = e.target && e.target.closest ? e.target.closest('.tc-card__image-wrap[data-alt-src]') : null;
        if (!wrap || wrap.getAttribute('data-alt-loaded')) return;
        wrap.setAttribute('data-alt-loaded', '1');
        var img = new Image();
        img.className = 'tc-card__image tc-card__image--alt';
        img.alt = '';
        img.onload = function () {
          wrap.appendChild(img);
          void img.offsetWidth;
          wrap.classList.add('has-alt');
        };
        img.src = wrap.getAttribute('data-alt-src');
      },
      true
    );
  }

  /* ---------- 6. save for later ---------- */
  function isSaved(handle) {
    return readList(SAVED_KEY).indexOf(handle) !== -1;
  }
  function paintSavedCount() {
    var n = readList(SAVED_KEY).length;
    $all('[data-tc-saved-link]').forEach(function (a) {
      a.hidden = n === 0;
    });
    $all('[data-tc-saved-count]').forEach(function (s) {
      if (s.textContent !== String(n)) s.textContent = n;
    });
  }
  function paintHearts() {
    var saved = readList(SAVED_KEY);
    $all('[data-tc-heart]').forEach(function (b) {
      var on = saved.indexOf(b.getAttribute('data-tc-heart')) !== -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = $('[data-tc-heart-label]', b);
      var text = on ? 'Saved' : 'Save for later';
      // Only write on change: this runs from a MutationObserver on <main>.
      if (label && label.textContent !== text) label.textContent = text;
      var view = b.parentNode && $('[data-tc-heart-view]', b.parentNode);
      if (view) view.hidden = !on;
    });
    paintSavedCount();
  }
  function toggleSaved(handle) {
    var list = readList(SAVED_KEY);
    var i = list.indexOf(handle);
    if (i === -1) list.unshift(handle);
    else list.splice(i, 1);
    writeList(SAVED_KEY, list.slice(0, SAVED_MAX));
    paintHearts();
    return i === -1;
  }
  function heartButton(handle, title) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tc-heart';
    b.setAttribute('data-tc-heart', handle);
    b.setAttribute('aria-pressed', isSaved(handle) ? 'true' : 'false');
    b.setAttribute('aria-label', 'Save ' + (title || 'this item') + ' for later');
    b.innerHTML = HEART;
    return b;
  }
  function decorate(root) {
    // Homepage cards, collection/search/related cards, and the rows built here.
    // On the theme's own cards the heart goes on the outer wrapper, as its last
    // child: the card's full-size link is drawn at the same layer, and only an
    // element that comes after it gets the click.
    $all(CARD_SEL, root).forEach(function (card) {
      if (card.getAttribute('data-tc-hearted')) return;
      var link = $('a[href*="/products/"]', card);
      var handle = link && handleFromUrl(link.getAttribute('href'));
      if (!handle) return;
      card.setAttribute('data-tc-hearted', '1');
      var titleEl = $('.tc-card__title, .card__heading, .tc-mini__title', card);
      card.appendChild(heartButton(handle, titleEl ? titleEl.textContent.trim() : ''));
    });
  }
  function productPageHeart() {
    if (!pageHandle || $('[data-tc-heart-row]')) return;
    var buttons = $('.product__info-container .product-form__buttons');
    if (!buttons) return;
    var row = document.createElement('div');
    row.className = 'tc-heart-row';
    row.setAttribute('data-tc-heart-row', '');
    row.innerHTML =
      '<button type="button" class="tc-heart tc-heart--inline" data-tc-heart="' +
      esc(pageHandle) +
      '" aria-pressed="false">' +
      HEART +
      '<span data-tc-heart-label>Save for later</span></button>' +
      '<a class="link tc-heart-row__view" data-tc-heart-view hidden href="' +
      SAVED_URL +
      '">View saved</a>';
    buttons.parentNode.insertBefore(row, buttons.nextSibling);
  }
  function savedEmptyState() {
    var page = $('[data-tc-saved-page]');
    if (!page) return;
    var ul = $('[data-tc-saved-list]', page);
    var empty = $('[data-tc-saved-empty]', page);
    if (ul && empty && !ul.children.length && !readList(SAVED_KEY).length) {
      empty.hidden = false;
      savedNote('');
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-tc-heart]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var added = toggleSaved(b.getAttribute('data-tc-heart'));
    if (added) {
      b.classList.remove('tc-heart--pop');
      void b.offsetWidth;
      b.classList.add('tc-heart--pop');
      return;
    }
    // On the saved page an un-hearted item leaves the list straight away.
    var li = b.closest('[data-tc-saved-list] > .tc-mini');
    if (li) {
      li.parentNode.removeChild(li);
      savedEmptyState();
    }
  });

  /* ---------- product rows built in the browser ---------- */
  // Each answer is one of: {product}, {gone: true} for a product that no
  // longer exists (404), or {failed: true} for anything else. Only "gone" is
  // ever allowed to remove an item from a list.
  function loadProduct(handle) {
    return getJson('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) {
        if (r.status === 404) return { handle: handle, gone: true };
        if (!r.ok) return { handle: handle, failed: true };
        return r.json().then(function (p) {
          return p && p.handle ? { handle: handle, product: p } : { handle: handle, failed: true };
        });
      })
      .catch(function () {
        return { handle: handle, failed: true };
      });
  }
  // Six at a time, in order, so a long saved list is not one burst of requests.
  function loadProducts(handles) {
    var results = new Array(handles.length);
    var next = 0;
    function worker() {
      if (next >= handles.length) return Promise.resolve();
      var i = next++;
      return loadProduct(handles[i]).then(function (r) {
        results[i] = r;
        return worker();
      });
    }
    var pool = [];
    for (var k = 0; k < Math.min(6, handles.length); k++) pool.push(worker());
    return Promise.all(pool).then(function () {
      return results;
    });
  }
  function forget(key, handles) {
    if (!handles.length) return;
    // Re-read first: the shopper may have changed the list while this loaded.
    writeList(
      key,
      readList(key).filter(function (h) {
        return handles.indexOf(h) === -1;
      })
    );
  }
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function miniCard(p) {
    var li = document.createElement('li');
    li.className = 'tc-mini' + (p.available ? '' : ' is-soldout');
    li.innerHTML =
      '<a class="tc-mini__link" href="' +
      esc(p.url) +
      '">' +
      '<span class="tc-mini__img">' +
      (p.featured_image ? '<img loading="lazy" width="300" height="300" alt="" src="' + esc(imgUrl(p.featured_image, 400)) + '">' : '') +
      '</span>' +
      '<span class="tc-mini__title">' +
      esc(p.title) +
      '</span>' +
      '<span class="tc-mini__price">' +
      (p.available ? money(p.price) : 'Sold out') +
      '</span></a>';
    return li;
  }
  // Run fn once el is within about a screen of the viewport.
  function whenNear(el, fn) {
    if (!('IntersectionObserver' in window)) {
      fn();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            io.disconnect();
            fn();
            return;
          }
        }
      },
      { rootMargin: '900px 0px' }
    );
    io.observe(el);
  }

  /* ---------- 7. recently viewed ---------- */
  function recordSeen() {
    if (!isProductPage()) return;
    var list = readList(SEEN_KEY).filter(function (h) {
      return h !== pageHandle;
    });
    list.unshift(pageHandle);
    writeList(SEEN_KEY, list.slice(0, SEEN_MAX));
  }
  function renderRecent() {
    if (!pageHandle && !onCartPage) return;
    var main = $('main');
    if (!main || $('[data-tc-recent], [data-tc-recent-anchor]')) return;
    // A couple of spares, since sold-out and removed products are skipped.
    var handles = readList(SEEN_KEY)
      .filter(function (h) {
        return h !== pageHandle;
      })
      .slice(0, 8);
    if (!handles.length) return;
    var anchor = document.createElement('div');
    anchor.setAttribute('data-tc-recent-anchor', '');
    // The theme hides every empty div, and a hidden element is never "near".
    anchor.style.cssText = 'display:block;height:1px;';
    main.appendChild(anchor);
    // The row sits at the very end of the page, so its product data is only
    // fetched once the shopper scrolls near it.
    whenNear(anchor, function () {
      loadProducts(handles).then(function (results) {
        forget(
          SEEN_KEY,
          results
            .filter(function (r) {
              return r.gone;
            })
            .map(function (r) {
              return r.handle;
            })
        );
        var items = results
          .filter(function (r) {
            return r.product && r.product.available;
          })
          .slice(0, 6);
        if (!items.length || !anchor.parentNode) {
          if (anchor.parentNode) anchor.parentNode.removeChild(anchor);
          return;
        }
        var sec = document.createElement('section');
        sec.className = 'tc-recent page-width';
        sec.setAttribute('data-tc-recent', '');
        sec.setAttribute('aria-label', 'Recently viewed');
        sec.innerHTML = '<h2 class="tc-recent__title h2">Recently viewed</h2><ul class="tc-mini-row list-unstyled" role="list"></ul>';
        var ul = $('ul', sec);
        items.forEach(function (r) {
          ul.appendChild(miniCard(r.product));
        });
        anchor.parentNode.replaceChild(sec, anchor);
        decorate(sec);
        paintHearts();
      });
    });
  }

  /* ---------- saved page ---------- */
  function savedNote(text) {
    var page = $('[data-tc-saved-page]');
    if (!page) return;
    var note = $('[data-tc-saved-note]', page);
    if (!text) {
      if (note) note.hidden = true;
      return;
    }
    if (!note) {
      var ul = $('[data-tc-saved-list]', page);
      if (!ul) return;
      note = document.createElement('p');
      note.className = 'tc-saved__note';
      note.setAttribute('data-tc-saved-note', '');
      note.setAttribute('role', 'status');
      ul.parentNode.insertBefore(note, ul);
    }
    note.textContent = text;
    note.hidden = false;
  }
  var savedRender = 0;
  function renderSavedPage() {
    var page = $('[data-tc-saved-page]');
    if (!page) return;
    var ul = $('[data-tc-saved-list]', page);
    var empty = $('[data-tc-saved-empty]', page);
    if (!ul || !empty) return;
    var handles = readList(SAVED_KEY);
    var mine = ++savedRender;
    if (!handles.length) {
      ul.innerHTML = '';
      empty.hidden = false;
      savedNote('');
      return;
    }
    empty.hidden = true;
    savedNote('Loading your saved items...');
    loadProducts(handles).then(function (results) {
      if (mine !== savedRender) return;
      var gone = [];
      var failed = 0;
      var current = readList(SAVED_KEY);
      ul.innerHTML = '';
      results.forEach(function (r) {
        if (r.gone) gone.push(r.handle);
        else if (!r.product) failed++;
        else if (current.indexOf(r.handle) !== -1) ul.appendChild(miniCard(r.product));
      });
      // Only a product that truly no longer exists leaves the list. A request
      // that merely failed keeps its place and is tried again next visit.
      forget(SAVED_KEY, gone);
      decorate(ul);
      paintHearts();
      empty.hidden = readList(SAVED_KEY).length > 0;
      if (!failed) savedNote('');
      else if (failed === results.length - gone.length) savedNote('Your saved items could not be loaded just now. Refresh the page to try again.');
      else savedNote('Some saved items could not be loaded just now. Refresh the page to try again.');
    });
  }

  /* ---------- after the Back button ---------- */
  // Browsers bring a page back exactly as it was left, so hearts, the cart
  // count and the shipping bar can all be out of date. Check once and repair.
  function bubbleCount() {
    var bubble = $('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return 0;
    var num = $('span[aria-hidden]', bubble);
    var n = num ? parseInt(num.textContent, 10) : NaN;
    return isNaN(n) ? -1 : n;
  }
  function syncAfterBack() {
    paintHearts();
    getJson('/cart.js')
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        if (cart.item_count === bubbleCount()) return;
        if (onCartPage) {
          // The cart itself is stale; only a fresh page is right.
          window.location.reload();
          return;
        }
        $all('[data-tc-ship]').forEach(function (el) {
          paintShip(el, cart.total_price, cart.total_weight);
        });
        return getJson('/?sections=cart-icon-bubble')
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (sections) {
            var html = sections && sections['cart-icon-bubble'];
            var icon = document.getElementById('cart-icon-bubble');
            if (!html || !icon) return;
            var sec = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
            if (sec) icon.innerHTML = sec.innerHTML;
          });
      })
      .catch(function () {});
  }
  window.addEventListener('pageshow', function (e) {
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (e.persisted || (nav && nav.type === 'back_forward')) syncAfterBack();
  });

  onReady(function () {
    watchPanel();
    recordSeen();
    productPageHeart();
    decorate(document);
    paintHearts();
    renderSavedPage();
    renderRecent();
    // Collection filters and sorting swap cards in without a page load. Only
    // react when cards (or the buy buttons) were actually added, so the page
    // costs nothing while it sits idle.
    var main = $('main');
    if (main && 'MutationObserver' in window) {
      var watch = CARD_SEL + ', .product-form__buttons';
      var queued = false;
      new MutationObserver(function (records) {
        if (queued) return;
        var hit = false;
        for (var i = 0; i < records.length && !hit; i++) {
          var added = records[i].addedNodes;
          for (var j = 0; j < added.length && !hit; j++) {
            var n = added[j];
            if (n.nodeType === 1 && n.matches && (n.matches(watch) || n.querySelector(watch))) hit = true;
          }
        }
        if (!hit) return;
        queued = true;
        setTimeout(function () {
          queued = false;
          productPageHeart();
          decorate(main);
          paintHearts();
        }, 150);
      }).observe(main, { childList: true, subtree: true });
    }
  });
  // Another tab saved or removed something.
  window.addEventListener('storage', function (e) {
    if (e.key === SAVED_KEY) paintHearts();
  });
})();
